import * as React from 'react';
import { i18n } from 'arm-common';
// let PureRenderMixin = require('react-addons-pure-render-mixin');

export default class aTextInput extends React.Component {
    // mixins: [PureRenderMixin],
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.componentName = "[aTextInput.jsx] ";
        this.state = {
            maxlength: 100,
            errorMessage: null
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.maxlength !== undefined && nextprops.maxlength !== null) {
            this.setState({ maxlength: nextprops.maxlength });
        }
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    onChange(event) {

        if (event.target.value !== null && '' + this.state.maxlength === '' + event.target.value.length) {
            this.setState({
                errorMessage: i18n('ARM_CORE_PRINT.SHARED.LUNGHEZZA_MAASIMA_RAGGIUNTA_PARAM_CARATTERI', 'Lunghezza massima raggiunta: #maxlength# caratteri',
                    'maxlength', this.state.maxlength)
            });
        }
        else {
            this.setState({ errorMessage: null });
        }

        if (this.props.onChange !== undefined && this.props.onChange !== null) {
            this.props.onChange(event);
        }
    }

    render() {
        console.log(this.componentName + 'RENDER: ' + this.props.id);

        let myPattern = "";
        if (this.props.myPattern) {
            myPattern = this.props.myPattern;
        }

        let maxlength = 100;
        if (this.props.maxlength) {
            maxlength = (this.props.maxlength * 1);
        }

        let formClass = 'form-group ';
        if (this.props.componentClass === null || this.props.componentClass === undefined) {
            formClass = formClass + " col-sm-6";
        }
        else {
            formClass = formClass + this.props.componentClass;
        }
        // console.log("this.props.componentClass: " + this.props.componentClass);
        // console.log("formClass: " + formClass);
        let name = null;
        if (this.props.name === undefined) {
            name = this.props.id;
        }
        else {
            name = this.props.name;
        }

        let isDisabled;
        if (this.props.disabled === undefined || this.props.disabled === null || this.props.disabled !== true) {
            isDisabled = false;
        }
        else {
            isDisabled = true;
        }

        let label = null;
        if (this.props.label === undefined) {
            label = this.capitalizeFirstLetter(name);
        } else {
            label = this.props.label;
        }

        //console.log("required: " + this.props.required);
        if (this.props.required === true && isDisabled === false) {
            //  console.log("is required: ");
            //console.log(label.indexOf('*'));
            if (label.indexOf('*') === -1) {
                label = label + '*';
            }
        }

        let messaggioDiErrore = null;
        let spanDiErrore = null;

        if (this.props.validation !== undefined) {
            //for (var [key, value] of this.props.validation) {
            //  console.log(key + ' = ' + value);
            //}

            //cerco un eventuale messaggio di errore per il mio componente
            let errore = this.props.validation.get(this.props.id);
            //console.log('Errore: ' + errore);

            if (errore !== undefined) {
                formClass += ' has-error has-feedback';
                //	spanClass = 'glyphicon glyphicon-remove form-control-feedback';
                messaggioDiErrore = <span className="text-danger small">{errore}</span>;
                spanDiErrore = <span className='glyphicon glyphicon-remove form-control-feedback' aria-hidden="true"></span>;
            }
        }

        if (this.state.errorMessage !== null) {
            formClass += ' has-error has-feedback';
            //	spanClass = 'glyphicon glyphicon-remove form-control-feedback';
            messaggioDiErrore = <span className="text-danger small">{this.state.errorMessage}</span>;
            spanDiErrore = <span className='glyphicon glyphicon-remove form-control-feedback' aria-hidden="true"></span>;
        }

        let myValue;
        if (this.props.value === undefined || this.props.value === null) {
            myValue = '';
        }
        else {
            myValue = this.props.value;
        }


        let myType;
        if (this.props.type === undefined || this.props.type === null) {
            myType = 'text';
        }
        else {
            myType = this.props.type;
        }


        let myLabelClass = "control-label ";
        if (this.props.labelClass !== undefined && this.props.labelClass !== null) {
            myLabelClass = this.props.labelClass;
        }

        //console.log('\tthis.props.value: ' + this.props.value);
        //console.log('\tmyValue: ' + myValue);
        return (
            <div className={formClass} >
                <label className={myLabelClass} htmlFor={this.props.id} >{label}</label>
                <input id={this.props.id} name={name} type={myType} value={myValue} className="form-control" maxLength={maxlength}
                    placeholder={this.props.placeholder} onChange={this.onChange} disabled={isDisabled} pattern={myPattern} />
                {spanDiErrore}
                {messaggioDiErrore}
            </div>
        );
    }
}  // no semicolon!